import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private storage: Storage | undefined;

  constructor(private ionStorage: Storage) {}

  async init(): Promise<void> {
    this.storage = await this.ionStorage.create();
  }

  set(key: string, value: any): Promise<void> {
    return this.storage.set(key, value);
  }

  get(key: string): Promise<any> {
    return this.storage.get(key);
  }

  remove(key: string): Promise<any> {
    return this.storage.remove(key);
  }
}
